import Tutorial from './Tutorial';
import common from '../../common';
import {translate} from '../../utils';
import WalkCommand from '../../commands/WalkCommand';
import JumpCommand from '../../commands/JumpCommand';

export default class TutorialLevel7 extends Tutorial {
	constructor(finger, panel, scene, commands) {
		super(finger, panel, scene, commands);
	}

	update() {
		super.update();
	}

	play() {
		super.play();

		if (this._destroyed) {
			return;
		}

		this.tweens.removeAll();

		let lastTween = null;

		this._scene.runButton.position.y = common.STAGE_HEIGHT - 220;

		if (this.stage === 0) {
			this._finger.alpha = 1;
			this._finger.scale.set(1, 1);
			this._finger.rotation = 0;
			this._finger.position.set(((common.STAGE_WIDTH - P3.View.width) * 0.5) + 250, 220);
			this._commands.ui.interactive = true;
			this._commands.ui.interactiveChildren = true;
			this._commands.ui.add.interactive = false;
			common.focusOverlay.setFocus(20, 125, 255, 100);

			this._panel.label.text = translate('GAME.TUTORIAL.STAGE7.CLICK_JUMP');
			this.signals.update.dispatch();

			new P3.utils.TWEEN.Tween(this._finger.scale, this.tweens)
				.to({
					x : 0.85,
					y : 0.85
				}, 250)
				.easing(P3.utils.Easing.Back2.Out)
				.repeat(1)
				.yoyo(true)
				.start();

			lastTween = new P3.utils.TWEEN.Tween(this._finger, this.tweens)
				.to({
					rotation: -5 * PIXI.DEG_TO_RAD
				}, 250)
				.easing(P3.utils.Easing.Back2.Out)
				.repeat(1)
				.yoyo(true)
				.start();
		} else if (this.stage === 1) {
			this._finger.alpha = 1;
			this._finger.scale.set(1, 1);
			this._finger.rotation = 0;
			this._finger.position.set(((common.STAGE_WIDTH - P3.View.width) * 0.5) + 420, 225);
			this._commands.ui.interactive = true;
			this._commands.ui.interactiveChildren = true;
			this._commands.ui.add.interactive = false;
			common.focusOverlay.setFocus(20, 125, 385, 100);

			this._panel.label.text = translate('GAME.TUTORIAL.STAGE7.CLICK_PLUS');
			this.signals.update.dispatch();

			new P3.utils.TWEEN.Tween(this._finger.scale, this.tweens)
				.to({
					x : 0.85,
					y : 0.85
				}, 250)
				.easing(P3.utils.Easing.Back2.Out)
				.repeat(1)
				.yoyo(true)
				.start();

			lastTween = new P3.utils.TWEEN.Tween(this._finger, this.tweens)
				.to({
					rotation: -5 * PIXI.DEG_TO_RAD
				}, 250)
				.easing(P3.utils.Easing.Back2.Out)
				.repeat(1)
				.yoyo(true)
				.start();
		} else if (this.stage === 2) {
			this._finger.alpha = 1;
			this._finger.scale.set(1, 1);
			this._finger.rotation = 0;
			this._finger.position.set((common.STAGE_WIDTH * 0.5) + 100 - this._commands.ui.x, common.STAGE_HEIGHT - 180);
			this._commands.ui.interactive = true;
			this._commands.ui.interactiveChildren = true;
			this._commands.ui.add.interactive = false;
			common.focusOverlay.focusSprite(this._scene.runButton, true);

			this._panel.label.text = translate('GAME.TUTORIAL.STAGE7.CLICK_RUN');
			this.signals.update.dispatch();

			new P3.utils.TWEEN.Tween(this._finger.scale, this.tweens)
				.to({
					x : 0.85,
					y : 0.85
				}, 250)
				.easing(P3.utils.Easing.Back2.Out)
				.repeat(1)
				.yoyo(true)
				.start();

			lastTween = new P3.utils.TWEEN.Tween(this._finger, this.tweens)
				.to({
					rotation: -5 * PIXI.DEG_TO_RAD
				}, 250)
				.easing(P3.utils.Easing.Back2.Out)
				.repeat(1)
				.yoyo(true)
				.start();
		}

		if (lastTween) {
			lastTween.onComplete(() => {
				P3.utils.delayg(this.tweens, 1, () => {
					this.play();
				});
			});
		}
	}

	stop() {
		super.stop();
	}

	prepareCommands() {
		super.prepareCommands();

		for (let i = 0; i < 3; i++) {
			let command = null;

			if (i !== 1) {
				command = new WalkCommand();
			} else {
				command = new JumpCommand();
			}

			command.template = false;
			command.grabbable = false;
			command.placed = true;
			command.locked = true;
			command.canChangeVariable = false;
			this._commands.commandContainer.addChild(command);
			command.x = 169;

			command.setText(command.defaultVariable);
			for (const comm of this._commands.commands) {
				comm.slotPosition.set(comm.position.x, comm.position.y);
			}

			if (i === 1) {
				command.interactive = true;
				command.canChangeVariable = true;
				command.variable = command.defaultVariable;
				command.signals.pickup.detachAll();
				command.signals.onVariableTouch.add(this._commands.onVariableTouch, this._commands);
			}

			this._commands.commands.splice(i + 1, 0, command);
			this._commands.resize();
		}
	}
}
